export const CategoriesUrl = `${process.env.REACT_APP_API_ENDPOINT}/categories`;
export const CategoryUrl = path => `${CategoriesUrl}/${path}`;
export const SubcategoryUrl = (categoryPath, subcategoryId) =>
  `${CategoriesUrl}/${categoryPath}/${subcategoryId}`;
export const UsersUrl = 'https://userendpoint-api.buildsofttools.com/users';
